import { useEffect } from "react"
import { useCartContext } from "@app/providers/cart"
import { useCustomerContext } from "@app/providers/customer"
import { useCart } from "@app/hooks/useCart"

export const useCartIdentityUpdate = () => {
  const { cart } = useCartContext()
  const { customer, token } = useCustomerContext()
  const { updateBuyerIdentity } = useCart()

  useEffect(() => {
    if (customer?.email && token && cart && cart?.buyerIdentity?.customer?.email !== customer.email) {
      updateBuyerIdentity({
        email: customer.email as string,
        customerAccessToken: token?.accessToken,
      })
    } else if (!token && !customer?.email && cart && cart?.buyerIdentity?.customer?.email) {
      updateBuyerIdentity({
        email: null,
        customerAccessToken: null,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart?.id, customer?.email])

  return null
}
